@if (loading_overview()) {
  <p class="loading-hint">Cargando trabajadores…</p>
} @else {
  <div class="bisual-table">
    <div class="bisual-table-container">
      <table mat-table [dataSource]="overview_data_source">
        <ng-container matColumnDef="user">
          <th mat-header-cell *matHeaderCellDef>Empleado</th>
          <td mat-cell *matCellDef="let element">{{ element.user_full_name }}</td>
        </ng-container>

        <ng-container matColumnDef="active_formation">
          <th mat-header-cell *matHeaderCellDef>Formación activa</th>
          <td mat-cell *matCellDef="let element">
            <span [matTooltip]="element.active_formation_name.length > 50 ? element.active_formation_name : null">
              {{ element.active_formation_name }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="hours">
          <th mat-header-cell *matHeaderCellDef>Horas imputadas</th>
          <td mat-cell *matCellDef="let element">{{ element.formation_hours_label }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <a
              mat-icon-button
              [routerLink]="['/employees', 'rrhh', 'formations', 'by-user', element.user.id]"
              matTooltip="Ver detalle"
              aria-label="Ver detalle"
            >
              <mat-icon>visibility</mat-icon>
            </a>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="overview_displayed_columns"></tr>
        <tr mat-row *matRowDef="let row; columns: overview_displayed_columns"></tr>
      </table>
    </div>
  </div>
}
